// This is our "legacy" adapter to load React Pages in Retail's routing system.
// We are not importing the class as it's used globally only. In this case
// we only want to import the file and have the code outside the class execute.
import './retail';

import * as React from 'react';
import { Route, Router as BrowserRouter } from 'react-router-dom';

import Loading from 'pages/views/generic/Loading';

import ErrorBoundary from '../components/ErrorBoundary';
import history from './history';

// This is a lazy loaded component that will load the React Router SPA routes.
const ReactPagesRouterSwitch = React.lazy(
  () => import(/* webpackChunkName: "ReactRouterSPA" */ './routeList')
);

interface Props {
  loading: boolean;
}

const Router: React.FunctionComponent<Props> = ({ loading }) => {
  return (
    <BrowserRouter history={history}>
      {loading ? (
        <Route component={Loading} />
      ) : (
        <ErrorBoundary>
          <React.Suspense
            fallback={
              <div data-test="suspenseFallback">
                <Loading />
              </div>
            }
          >
            <ReactPagesRouterSwitch />
          </React.Suspense>
        </ErrorBoundary>
      )}
    </BrowserRouter>
  );
};

export default Router;
